import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface PasswordFormFieldProps {
  label: string;
  helpText?: string;
  name: string;
  placeholder?: string;
  value?: string;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  validated?: boolean;
  onChange?: (event: React.ChangeEvent<any>) => void;
  className?: string;
  autoComplete?: string;
}

const PasswordFormField: React.FC<PasswordFormFieldProps> = ({
  label,
  helpText,
  name,
  placeholder,
  value,
  error = false,
  errorMessage,
  disabled = false,
  validated = false,
  onChange,
  className,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Form.Group className={className}>
      <Form.Label data-variant="label-2-bold">{label}</Form.Label>
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
      <div className="position-relative">
        <Form.Control
          size="lg"
          name={name}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          isInvalid={error && validated}
          isValid={!error && validated}
          autoComplete={autoComplete}
          style={{ paddingRight: "40px" }} // Add padding to accommodate the icon
        />
        <div
          className="position-absolute"
          style={{
            top: "8px",
            right: error && validated ? "26px" : "10px",
            cursor: "pointer",
            zIndex: 10,
            pointerEvents: "auto",
          }}
          onClick={togglePasswordVisibility}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </div>
        {error && validated && (
          <Form.Control.Feedback type="invalid">
            {errorMessage || `Invalid ${label.toLowerCase()}`}
          </Form.Control.Feedback>
        )}
      </div>
    </Form.Group>
  );
};

export default PasswordFormField;
